import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import {connect} from "react-redux";
import {Option, option} from "ts-option";
import Loading from "../../../ui/loading/Loading";
import {api} from "../../../../api/api";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Toast from "../../../helper/Toast";
import Row from "../../../layout/Row";
import Col from "../../../layout/Col";
import {BrandJobTypeUtilityApiDto} from "../../../../api/model/rest";
import Utility from "../../../../model/utility/Utility";
import SelectUtility from "../../utilities/form/SelectUtility";
import {fetchUtilities} from "../../../../store/action/utility/utility";
import "../../shared/jobTypeModal.scss";

interface IComponentProps {
	brandId: string;
	onFinish: () => void;
}

interface ReduxProps {
	dispatch: any;
}

interface IState {
	rows: Option<BrandJobTypeUtilityApiDto[]>;
	processing: boolean;
}

type Props = IComponentProps & ReduxProps;

class BrandJobTypeUtilitiesModal extends React.Component<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {
			rows: option(null),
			processing: false
		};
		this.save = this.save.bind(this);
		this.changeUtility = this.changeUtility.bind(this);
	}

	componentDidMount() {
		this.props.dispatch(fetchUtilities());
		api.instance.brandApi.fetchJobTypeUtilities(this.props.brandId)
			.then(rows => this.setState({rows: option(rows)}))
			.catch(err => {
				this.setState({rows: option([])});
				notifyBugsnagAndShowToast(err, "Fetching job type utilities failed");
			});
	}

	changeUtility(jobTypeId: string, utility: Option<Utility>) {
		const rows = this.state.rows.map(
			list => list.map(r => r.jobTypeId === jobTypeId
				? {...r, utilityId: utility.isDefined ? utility.get.id : undefined}
				: r)
		).getOrElse([]);
		this.setState({rows: option(rows)});
	}

	save() {
		const updates = this.state.rows.map(list => list.map(r => ({
			jobTypeId: r.jobTypeId,
			utilityId: r.utilityId != null ? r.utilityId : undefined
		}))).getOrElse([]);

		this.setState({processing: true}, () => {
			api.instance.brandApi.updateJobTypeUtilities(this.props.brandId, updates)
				.then(() => {
					this.setState({processing: false}, () => {
						this.props.onFinish();
						Toast.success("Brand job type utilities updated", "Update success");
					});
				})
				.catch(err => {
					this.setState({processing: false},
						() => notifyBugsnagAndShowToast(err, "Update job type utilities failed"));
				});
		});
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onFinish} mediumWidth oveflowUnset title={"Job type utilities"}>
				<Loading isLoading={this.state.rows.isEmpty}>
					<div className={"c-job-type-modal-table"}>
						<Row customClass={"header"}>
							<Col xl={6} md={6}>Job Type</Col>
							<Col xl={6} md={6}>Default Utility</Col>
						</Row>
						{this.state.rows.getOrElse([]).map(row => (
							<Row key={row.jobTypeId}>
								<Col xl={6} md={6}>{row.jobTypeName}</Col>
								<Col xl={6} md={6}>
									<SelectUtility
										placeholder={"None"}
										selectedId={option(row.utilityId)}
										onChanged={(u: Option<Utility>) => this.changeUtility(row.jobTypeId, u)}
										clearable={true}
										portalMenu={true}/>
								</Col>
							</Row>
						))}
						<div className={"c-job-type-modal-table_buttons-bar"}>
							<ButtonTertiary label={"Cancel"} onClick={this.props.onFinish}/>
							<ButtonPrimary isLoading={this.state.processing}
										   label={"Save configuration"}
										   onClick={this.save}/>
						</div>
					</div>
				</Loading>
			</Modal>
		);
	}
}

export default connect()(BrandJobTypeUtilitiesModal);
